import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import Svg, { Circle } from 'react-native-svg';
import { useAnimatedProps } from 'react-native-reanimated';
import useColors from 'hooks/useColors';
import { AnimatedCircle } from './AnimatedComponents';
import { rem } from './values';
const L = 200;
const R = 88;
const circumference = 2 * Math.PI * R;
const STROKE_WIDTH = 12;
const ReanimatedCircularProgress = ({ children, progressSharedValue }) => {
    const colors = useColors();
    const progressCircleColor = colors.gradients.ultimate.colors[0];
    const backgroundCircleColor = colors.cards.onDark;
    const animatedProps = useAnimatedProps(() => ({
        strokeDashoffset: circumference * (1 - progressSharedValue.value),
    }));
    return (<View>
      <Svg viewBox={`0 0 ${L} ${L}`} width={L} height={L}>
        <Circle r={R} cx={L / 2} cy={L / 2} strokeWidth={STROKE_WIDTH} fill="transparent" stroke={backgroundCircleColor}/>
        <AnimatedCircle r={R} cx={L / 2} cy={L / 2} strokeWidth={STROKE_WIDTH} fill="transparent" strokeLinecap="round" stroke={progressCircleColor} animatedProps={animatedProps} strokeDasharray={circumference} transform={`rotate(-90,${L / 2},${L / 2})`}/>
      </Svg>
      <View style={styles.childrenContainer}>{children}</View>
    </View>);
};
const styles = StyleSheet.create({
    childrenContainer: {
        ...StyleSheet.absoluteFillObject,
        bottom: rem(4),
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default memo(ReanimatedCircularProgress);
